import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout';
import { useMantenedores } from '../../context/MantenedoresContext';
import { useTarifariosMantenedor } from '../../hooks/useTarifariosMantenedor';
import TarifariosTable from '../../components/Tarifarios/TarifariosTable';
import TarifariosFiltersButton from '../../components/Tarifarios/TarifariosFiltersButton';
import TarifariosFilters from '../../components/Tarifarios/TarifariosFilters';

const TarifarioCompleto = () => {
    const user = useSelector(state => state.auth.user);
    const { userPermissions } = useMantenedores();
    const permisos = userPermissions?.modules?.tarifarios || {};

    // Estado para el modal de filtros
    const [showFiltersModal, setShowFiltersModal] = useState(false);

    const {
        tarifarios,
        total,
        loading,
        error,
        pageSize,
        pageNumber,
        tipoTarifarioId,
        tiposTarifario,
        comunaId,
        comunas,
        servicioId,
        servicios,
        clienteId,
        clientes,
        regionId,
        regiones,
        tms,
        tmsId,
        handlePageChange,
        handlePageSizeChange,
        handleTipoTarifarioChange,
        handleComunaChange,
        handleServicioChange,
        handleClienteChange,
        handleRegionChange,
        handleTmsChange,
        isClienteEnabled,
        refreshData
    } = useTarifariosMantenedor(user, permisos);

    // Contar filtros activos (excluyendo tipoTarifarioId)
    const getActiveFiltersCount = () => {
        let count = 0;
        if (regionId) count++;
        if (comunaId) count++;
        if (servicioId) count++;
        if (tmsId) count++;
        if (clienteId) count++;
        return count;
    };

    const handleOpenFilters = () => {
        setShowFiltersModal(true);
    };

    const handleCloseFilters = () => {
        setShowFiltersModal(false);
    };

    const handleApplyFilters = (filters) => {
        // Aplicar los filtros recibidos del modal
        if (filters.regionId !== undefined) {
            handleRegionChange(filters.regionId);
        }
        if (filters.comunaId !== undefined) {
            handleComunaChange(filters.comunaId);
        }
        if (filters.servicioId !== undefined) {
            handleServicioChange(filters.servicioId);
        }
        if (filters.tmsId !== undefined) {
            handleTmsChange(filters.tmsId);
        }
        if (filters.clienteId !== undefined) {
            handleClienteChange(filters.clienteId);
        }
        setShowFiltersModal(false);
    };

    // Handler para cambios de región desde el modal
    const handleModalRegionChange = (regionId) => {
        handleRegionChange(regionId);
    };

    // Obtener tipo de tarifario actual
    const tipoTarifarioActual = tiposTarifario.find(tipo => tipo.id == tipoTarifarioId);

    // Handler para cuando se actualiza un tarifario
    const handleTarifarioUpdated = (tarifarioId, nuevoPrecio, nuevaModalidad) => {
        console.log('Tarifario actualizado:', { tarifarioId, nuevoPrecio, nuevaModalidad });
        // Refrescar los datos para mostrar los cambios
        setTimeout(() => {
            refreshData();
        }, 500); // Pequeño delay para asegurar que la actualización se completó en el servidor
    };

    return (
        <SimpleMantenedorLayout
            mantenedorId="tarifarios"
            title="Tarifario Completo"
            subtitle="Lista completa de tarifarios del sistema"
            iconColor="#007bff"
            showBackButton={false}
            backButtonPath="/mantenedores/tarifarios"
            breadcrumbs={[
                {
                    label: 'Tarifarios',
                    path: '/mantenedores/tarifarios'
                },
                {
                    label: 'Tarifario Completo'
                }
            ]}
        >
            {error && <div className="alert alert-danger mb-2">{error}</div>}
            
            <TarifariosTable
                data={tarifarios}
                loading={loading}
                total={total}
                pageSize={pageSize}
                pageNumber={pageNumber}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                tipoTarifarioId={tipoTarifarioId}
                tiposTarifario={tiposTarifario}
                onTipoTarifarioChange={handleTipoTarifarioChange}
                permisos={permisos}
                onTarifarioUpdated={handleTarifarioUpdated}
            >
                <TarifariosFiltersButton 
                    onOpenFilters={handleOpenFilters}
                    activeFiltersCount={getActiveFiltersCount()}
                />
            </TarifariosTable>

            <TarifariosFilters
                show={showFiltersModal}
                onHide={handleCloseFilters}
                onFiltersChange={handleApplyFilters}
                initialFilters={{
                    regionId,
                    comunaId,
                    servicioId,
                    tmsId,
                    clienteId
                }}
                tipoTarifario={tipoTarifarioActual?.tipo || 'ingreso'}
                regiones={regiones}
                comunas={comunas}
                servicios={servicios}
                tms={tms}
                clientes={clientes}
                onRegionChange={handleModalRegionChange}
            />
        </SimpleMantenedorLayout>
    );
};

export default TarifarioCompleto;
